import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { LocationStrategy } from "@angular/common";
import { IBaseModel } from "../models/base.model";
import { ISolicitacaoTecnicaModel } from "../models/solicitacao-tecnica.model";
import { INotaAuditoriaExecucaoModel } from "../models/nota-auditoria-execucao.model";
import {
  IArquivoItemModel, IArquivoRespostaModel,
  IItemSolicitacaoTecnicaModel,
  IRepostaItemModel
} from "../models/item-solicitacao-tecnica.model";
import { INotaItemAuditoriaExecucaoModel } from "../models/nota-item-auditoria-execucao.model";

@Injectable({
  providedIn: "root",
})

export class NotaAuditoriaExecucaoService extends BaseService {
  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }
  public async obter(
    osaExecucaoId: number,

  ): Promise<IBaseModel<INotaAuditoriaExecucaoModel[]>> {
    return this.httpClient
      .get<IBaseModel<INotaAuditoriaExecucaoModel[]>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/obter/${osaExecucaoId}`
      )
      .toPromise();
  }
  public async cancelarNotaAuditoriaExecucao(
    id: number,
    justificativa: string,
    responsavelId: string
  ): Promise<IBaseModel<INotaItemAuditoriaExecucaoModel>> {
    return this.httpClient
      .patch<IBaseModel<INotaItemAuditoriaExecucaoModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}/cancelar`,
        { justificativa, responsavelId }
      )
      .toPromise();
  }
  public async obterItemId(
    notaAuditoriaExecucaoId: number,
    id: number
  ): Promise<IBaseModel<INotaItemAuditoriaExecucaoModel>> {
    return this.httpClient
      .get<IBaseModel<INotaItemAuditoriaExecucaoModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${notaAuditoriaExecucaoId}/item/${id}`
      )
      .toPromise();
  }

  public async excluirAnexoItemResposta(arquivo: IArquivoRespostaModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/item/anexo-resposta/${arquivo.id}/excluir`
      )
      .toPromise();
  }

  public async avaliarItem(data: INotaItemAuditoriaExecucaoModel): Promise<IBaseModel<any>> {
    return this.httpClient
      .put<IBaseModel<any>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/item/avaliar`, data
      )
      .toPromise();
  }

  public async downloadArquivoRespostaItem(
    arquivo: IArquivoRespostaModel
  ): Promise<IBaseModel<string>> {
    return this.httpClient
      .get<IBaseModel<string>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/item/resposta/${arquivo.id}/anexo-resposta/download`
      )
      .toPromise();
  }

  public async obterPorId(
    id: number,

  ): Promise<IBaseModel<INotaAuditoriaExecucaoModel>> {
    return this.httpClient
      .get<IBaseModel<INotaAuditoriaExecucaoModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}`
      )
      .toPromise();
  }
  public async salvarItemResposta(
    itemNotaAuditoriaId: number,
    itemResposta: IRepostaItemModel
  ): Promise<IBaseModel<IRepostaItemModel>> {
    return this.httpClient
      .post<IBaseModel<IRepostaItemModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/item/${itemNotaAuditoriaId}/resposta`,
        itemResposta
      )
      .toPromise();
  }
  public async salvarNotaAuditoriaExecucao(
    data: INotaAuditoriaExecucaoModel
  ): Promise<IBaseModel<INotaAuditoriaExecucaoModel>> {
    return this.httpClient
      .post<IBaseModel<INotaAuditoriaExecucaoModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/salvar`,
        data
      )
      .toPromise();
  }

  public async cancelarItem(
    id: number,
    itemId: number,
    justificativa: string,
    responsavelId: string
  ): Promise<IBaseModel<void>> {
    return this.httpClient
      .patch<IBaseModel<void>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}/item/${itemId}/cancelar`,
        { justificativa, responsavelId }
      )
      .toPromise();
  }

  public async downloadAnexo(
    itemId: number,
    anexoId: number
  ): Promise<IBaseModel<IArquivoItemModel>> {
    return this.httpClient
      .get<IBaseModel<IArquivoItemModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/item/${itemId}/anexo/${anexoId}/download`,
        {}
      )
      .toPromise();
  }

  public async finalizarItem(id: number): Promise<IBaseModel<any>> {
    return this.httpClient
      .put<IBaseModel<any>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/item/${id}/finalizar`,
        {}
      )
      .toPromise();
  }

  public async salvarItem(
    data: INotaItemAuditoriaExecucaoModel
  ): Promise<IBaseModel<INotaItemAuditoriaExecucaoModel>> {
    return this.httpClient
      .post<IBaseModel<INotaItemAuditoriaExecucaoModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/salvar-item`,
        data
      )
      .toPromise();
  }

  public async avaliarProrrogacao(
    id: number, dados: any
  ): Promise<IBaseModel<any>> {
    return this.httpClient
      .patch<IBaseModel<any>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}/avaliar`, dados
      )
      .toPromise();
  }

  public async enviar(
    id: number
  ): Promise<IBaseModel<ISolicitacaoTecnicaModel>> {
    return this.httpClient
      .patch<IBaseModel<ISolicitacaoTecnicaModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}/enviar`,
        {}
      )
      .toPromise();
  }

  public async enviarItem(id: number): Promise<IBaseModel<any>> {
    return this.httpClient
      .put<IBaseModel<any>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/item/${id}/enviar`,
        {}
      )
      .toPromise();
  }

  public async prorrogarPrazo(
    id: number, dados: any
  ): Promise<IBaseModel<any>> {
    return this.httpClient
      .patch<IBaseModel<any>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}/prorrogar-prazo`, dados
      )
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}/excluir`,
        {}
      )
      .toPromise();
  }

  public async excluirItem(
    id: number,
    itemId: number
  ): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}/item/${itemId}/excluir`,
        {}
      )
      .toPromise();
  }

  public async finalizar(
    id: number
  ): Promise<IBaseModel<INotaAuditoriaExecucaoModel>> {
    return this.httpClient
      .patch<IBaseModel<INotaAuditoriaExecucaoModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}/finalizar`,
        {}
      )
      .toPromise();
  }
  public async excluirAnexo(
    id: number,
    itemId: number,
    anexoId: number
  ): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/${id}/item/${itemId}/anexo/${anexoId}/excluir`,
        {}
      )
      .toPromise();
  }

  public async salvarAnexo(dados: any	): Promise<IBaseModel<IArquivoItemModel>> {
    return this.httpClient
      .post<IBaseModel<IArquivoItemModel>>(
        `${this.apiBaseUrl}/nota-auditoria-execucao/item/salvar-anexo`,
        dados
      )
      .toPromise();
  }


}
